/**
 * Deduplicate tasks by ID to prevent duplicate key warnings.
 * This can happen in multi-campaign mode during sync operations.
 */
export default function deduplicateTasks(tasks) {
  const seenIds = new Set();
  return tasks.filter(task => {
    if (seenIds.has(task.id)) {
      console.warn(`[NodeRenderer] Duplicate task ID detected: ${task.id} (${task.name})`);
      return false;
    }
    seenIds.add(task.id);
    return true;
  });
}
